export default __webpack_public_path__ + "media/images/icons/ltc-489c3780073afcc709a135ed9d424079.png";